module.exports = __webpack_public_path__ + "media/images/ogp-c491b58f1ed4aba8f4ffbec4465061e6.png";